import { render, staticRenderFns } from "./PreviewMaterials.vue?vue&type=template&id=11baa521&"
import script from "./PreviewMaterials.vue?vue&type=script&lang=js&"
export * from "./PreviewMaterials.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMaterials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports